// Formats a video duration in seconds as m:ss (or h:mm:ss)
export const formatDuration = (secs) => {
  if (!Number.isFinite(secs)) return ''
  const total = Math.round(secs)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = String(total % 60).padStart(2, '0')
  return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`
}
